import { useId } from "react";
import { useTranslation } from "react-i18next";
import type { Review } from "../../../api/content/reviewDecoders";
import CheckResultList from "../checks/CheckResultList";

/** The checks of the head: shapes, competency questions, consistency (FR-MODEL-2 to 5), and
 * the process graph's shapes and questions when they ran (process-governance.md PG-3). */
export default function ChecksPanel({ review }: { review: Review }) {
  const { t } = useTranslation();
  const headingId = useId();
  const checks = review.checks;
  return (
    <section className="app-card space-y-2 p-3" aria-labelledby={headingId}>
      <h3 id={headingId} className="app-title text-base font-semibold">{t("reviews.checks.title")}</h3>
      {checks === null ? <p className="app-text-muted text-sm">{t("reviews.checks.notRun")}</p> : <CheckResultList results={checks.results} />}
      {checks?.processResults ? (
        <div className="space-y-2 border-t pt-2">
          <h4 className="app-title text-sm font-semibold">{t("reviews.checks.process")}</h4>
          <p className="app-text-muted text-xs">{t("reviews.checks.processNote")}</p>
          <CheckResultList results={checks.processResults} />
        </div>
      ) : null}
    </section>
  );
}
